export const filesRelationship = {
    collapsible: false,
    title: 'Files',
    tint: 'default',
    type: 'files',
};
